import { render, staticRenderFns } from "./Brac.vue?vue&type=template&id=e1d1f430&lang=pug"
import script from "./Brac.vue?vue&type=script&lang=js"
export * from "./Brac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports